module.exports = __webpack_public_path__ + "img/100.c386d161.png";